import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://zjhtjnjqwvtufmzlqvag.supabase.co'
const SUPABASE_ANON_KEY = 'sb_publishable_NDn5pnJTuimB7L7yS2aljA_oRFIbrPz'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
